import { PROJECT_MEMBERSHIP_ROLES_KEY } from '../core/constants';
import { ProjectTeamMemberLite } from './dashboard/types';

const DOCUSIGN_DOMAINS = ['docusign.com'];

export const isDocusignLinkValid = (docusignLink: any) => {
  if (!docusignLink || typeof docusignLink !== 'string') {
    return false;
  }

  try {
    const url = new URL(docusignLink);
    return DOCUSIGN_DOMAINS.some(domain => url.hostname.includes(domain));
  } catch {
    return false;
  }
};

export const sumFtePositionsCount = (data: any) => {
  return (data || []).reduce((acc: any, curr: any) => acc + Number(curr.requiredFte || 0), 0).toFixed(2);
};

type ProjectWithTeam = {
  projectManager?: string;
  team?: {
    members?: ProjectTeamMemberLite[];
  };
};

export const getProjectManagerAlias = (members?: ProjectTeamMemberLite[]) =>
  members?.find(
    member =>
      member.role === PROJECT_MEMBERSHIP_ROLES_KEY.PROJECT_MANAGER &&
      member.isBackup === false &&
      member.isBench === false,
  )?.employeeAlias;

export const getProjectManager = (project?: ProjectWithTeam) =>
  getProjectManagerAlias(project?.team?.members) ?? project?.projectManager;
